import type React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';
import { CopyButton } from '@vlabs/uikit';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './ResetUserPasswordConfirmation.module.sass';
import { useResetUserPasswordTranslation } from '../../i18n';

const displayName = 'ResetUserPasswordConfirmation';
const testid = buildTestid(displayName);

interface ResetUserPasswordConfirmationProps extends WithDataTestid {
  onClose: VoidFunction;
  url: string;
}

function ResetUserPasswordConfirmation({
  onClose,
  url,
  'data-testid': dataTestId = undefined,
}: ResetUserPasswordConfirmationProps): React.JSX.Element {
  const { t } = useResetUserPasswordTranslation();
  return (
    <div
      className={st.ResetUserPasswordConfirmation}
      {...testid(dataTestId)}
    >
      <div className={st.Header}>
        <InfoCircleFilledIcon className={st.Icon} />

        <div className={st.Description}>
          <span className={st.Title}>{t('confirm_title')}</span>
          <div className={st.SubtitleContainer}>
            <span className={st.Subtitle}>{t('confirm_description')}</span>
            <CopyButton
              className={st.CopyButton}
              label={t('confirm_link')}
              value={url}
            />
          </div>
        </div>
      </div>

      <Button
        className={st.Action}
        onClick={onClose}
      >
        {t('confirm_button')}
      </Button>
    </div>
  );
}

ResetUserPasswordConfirmation.displayName = displayName;

export { ResetUserPasswordConfirmation };
